import api from '@/api';

import { API_BASE_URL } from '..';
import { Message, MessageCreateRequest } from './Message.types';

const baseUrl = `${API_BASE_URL}/messages`;

export async function createMessage(
  obj: MessageCreateRequest,
): Promise<Message> {
  const result = (await api.post(`${baseUrl}`, obj, null)) as unknown;

  return result as Message;
}
